// extracted by mini-css-extract-plugin
module.exports = {"selected":"styles_selected__1h9Bj"};